import React from "react";
import { Img } from "../../../core/design-system/Img";
import { Text } from "../../../core/design-system/Text";

interface DatePickerProps {
  // Define your prop types here
}

const DatePicker: React.FC<DatePickerProps> = (props) => {
  return (
    <div className="flex  flex-row p-2 pr-4  border border-gray-300_01 rounded-lg gap-4">
      <Img src="Avatar.svg" alt="back" />
      <div className="flex flex-col">
        <div className="flex felx-row gap-1 items-center">
          <Text
            size="md"
            className="whitespace-nowrap  text-[16px] text-gray-50_04 font-medium"
          >
            Last Month
          </Text>
          <Img src="img_arrowdown.svg" alt="back" className="w-5 h-5" />
        </div>
        <Text
          size="s"
          className="whitespace-nowrap  text-[12px] font-medium color-gray-50_04 text-left opacity-50"
        >
          May 2024
        </Text>
      </div>
    </div>
  );
};

export default DatePicker;
